/**
 *
 * Asynchronously loads the component for Pricing
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const Login = lazyLoad(
  () => import('./index'),
  (module: { Login: any }): any => module.Login,
);
